import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AbstractPropertyEditor } from '../types';

@Injectable({
  providedIn: 'root'
})
export class ControlNameService {
  /**
   * å¤çæ§ä»¶åç§°
   *
   */
  public handleName: (name: string, editor: AbstractPropertyEditor) => Observable<string>;

  /**
   * å¤ççº§èä¸çº§æ§ä»¶åç§°
   *
   */
  public handleCaseCadeParentName: (name: string, editor: AbstractPropertyEditor) => Observable<string>;

  constructor() {}
}
